import axios from 'axios';
import UrlsUtil from '../../utils/url.util';

const apiBaseUrl = UrlsUtil.determineApiBaseUrl(window);

export default class ArchiveService {
  static getAll = async (): Promise<any> => {
    const url = `${apiBaseUrl}/api/Event/all`;
    return await axios.get(url);
  };
};